import { use, useEffect, useState } from "react";
import { LiveOrderInfoDTO } from "../../../../models/shared/response";
import { useParams } from "react-router-dom";
import { useNotification } from "../../../toster-notification/NotificationContext";
import Loader from "../../../shared/Loader";
import { orderService } from "../../../../services/orderService";
import { handleErrorNotification } from "../../../../utils/errorNotificatioMessage";
import OrderInfoView1 from "../views/side-views/OrderInfoView1";
import { OrderStatusType, orderStatusTypeToString } from "../../../../models/base/OrderStatusType";
import LiveOrdersDineInPage from "../../dinein/LiveOrdersDineInPage";
import { DineInWhiteIcon, DollarGreenIcon } from "../../../../assets/icons";

interface SideOrderInfoProps {
    selectedOrderId: string;
    onStatusChange: () => void;
    listItemOrder?: boolean;
}

const SideOrderInfo: React.FC<SideOrderInfoProps> = ({ selectedOrderId, onStatusChange, listItemOrder }) => {

    const [order, setOrder] = useState<LiveOrderInfoDTO | null>(null);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    const localId = useParams().localId;


    useEffect(() => {
        fetchOrderInfo();
    }, [selectedOrderId]);


    const fetchOrderInfo = async () => {
        if (!selectedOrderId || !localId)
            return;

        setLoading(true);
        try {
            const response = await orderService.getLiveOrderInList(localId, selectedOrderId);
            if (response.success && response.data) {
                setOrder(response.data);
            } else {
                notify("error", "Greška pri učitavanju porudžbine");
            }
        } catch (error) {
            notify("error", "Greška pri učitavanju porudžbine");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const handleOrderStatusChange = async (orderId: string, newStatus: OrderStatusType) => {
        if (!localId) {
            notify("error", "ID lokala nije prosleđen");
            return;
        }

        if (!orderId) {
            notify("error", "ID porudžbine nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.changeOrderStatus(localId, orderId, newStatus);

            if (response.success) {
                notify("success", "Uspešno ažuriran status porudžbine.");
                onStatusChange();
            } else {
                notify("error", "Greška pri ažuriranju statusa porudžbine", response.message || "Došlo je do greške pri ažuriranju statusa porudžbine.");
            }
        } catch (error) {
            notify("error", "Greška pri ažuriranju statusa porudžbine", "Došlo je do greške pri ažuriranju statusa porudžbine.");
            console.error(error);
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const handleOrderStatusToNext = async (orderId: string) => {
        if (!localId) {
            notify("error", "ID lokala nije prosleđen");
            return;
        }

        if (!orderId) {
            notify("error", "ID porudžbine nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.changeOrderStatusToNext(localId, orderId);

            if (response.success) {
                notify("success", "Uspešno ažuriran status porudžbine.");
                onStatusChange();
            }
            else {
                notify("error", "Greška pri ažuriranju statusa porudžbine", response.message || "Došlo je do greške pri ažuriranju statusa porudžbine.");
            }
        } catch (error) {
            notify("error", "Greška pri ažuriranju statusa porudžbine", "Došlo je do greške pri ažuriranju statusa porudžbine.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };


    if (!selectedOrderId) {
        return (
            <div className="admin-settings-box-div lo-table-info-block orders-list">
                Izaberite porudžbinu sa liste
            </div>
        )
    }

    if (!order) {
        return (
            <div className="admin-settings-box-div lo-table-info-block orders-list">
                Nema podataka o izabranoj porudžbini
            </div>
        )
    }

    if (loading) {
        return (
            <div className="admin-settings-box-div lo-table-info-block orders-list">
                <Loader fullscreen={false} />
            </div>
        )
    }


    return (
        <div className="admin-settings-box-div lo-table-info-block orders-list">
            <div className="lo-table-info-header">
                <div className="lo-table-info-header-image-div">
                    <img loading="lazy" src={DineInWhiteIcon} alt="" className="lo-table-info-header-image" />
                </div>
                <div className="div-block-15">
                    <div className="lo-table-info-table-number">Porudzbina #{order.id}</div>
                    <div className="lo-table-info-table-status">Status: {orderStatusTypeToString(order.currentStatus)}</div>
                </div>
            </div>
            <div className="lo-table-active-status-div">
                <div className="admin-settings-box-div lo-table-status">
                    <div className="lo-table-active-orders-bg">
                        <div className="lo-table-active-orders-icon"></div>
                    </div>
                    <div>
                        <div className="text-block-14">Stavke </div>
                        <div className="lo-table-active-orders-number">{order.items.length}</div>
                    </div>
                </div>
                <div className="admin-settings-box-div lo-table-status">
                    <div className="lo-table-active-orders-bg total-amount">
                        <img loading="lazy" src={DollarGreenIcon} alt="" className="icon-size-20" />
                    </div>
                    <div>
                        <div className="text-block-14">Ukupno</div>
                        <div className="lo-table-active-orders-number">
                            {order.items.reduce((total, item) => total + item.productVariantPrice * item.quantity, 0).toFixed(2)} RSD
                        </div>
                    </div>
                </div>
            </div>
            <div className="lo-table-orders-block-div">
                <div className="lo-table-orders-list-div">
                    <OrderInfoView1
                        key={order.id}
                        order={order}
                        handleOrderStatusChange={handleOrderStatusChange}
                        handleOrderStatusToNext={handleOrderStatusToNext}
                        listItemOrder={listItemOrder}
                    />
                </div>
            </div>
        </div>

    )
};

export default SideOrderInfo;